import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { MarketDataHistoryQuery } from "@/api/types";
import { dateToYYYYMMDD } from "@/utils/date";

export const MARKET_DATA_HISTORY_QUERY = gql`
  query GetMarketDataHistory($securityId: Long, $startDate: String) {
    security(id: $securityId) {
      id
      name
      securityCode
      marketDataHistory(startDate: $startDate) {
        obsDate
        close1
      }
    }
  }
`;

export const useGetMarketDataHistory = (
  securityId: string | number | undefined,
  _startDate: Date
) => {
  const startDate = dateToYYYYMMDD(_startDate);
  const { loading, error, data, refetch } = useQuery<MarketDataHistoryQuery>(
    MARKET_DATA_HISTORY_QUERY,
    {
      variables: { securityId, startDate },
      ...getFetchPolicyOptions(
        `useGetMarketDataHistory.${securityId}.${startDate}`
      ),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data && data,
    refetch,
  };
};
